export default __webpack_public_path__ + "static/media/svg-decorator-blob-8.7f469eaf.svg";